export default __webpack_public_path__ + "static/media/bitwa.c073f37f.png";